import { useParams } from "react-router-dom";
import { UserDetailProvider } from "../core/QueryResponseProvider";
import DetailUser from "./DetailUser";

const DetailUserWrapper = () => {
  const { id } = useParams();
  return (
    <UserDetailProvider id={id ?? ""}>
      <DetailUser />
    </UserDetailProvider>
  );
};

export default DetailUserWrapper;
